import { request } from '../../utils/request';

export const getProductsHashtags = (query: string) =>
  request({
    method: 'GET',
    url: `/products/hash-tags?query=${query}`,
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
